import { h, Host } from "@stencil/core";
import copyToClipboard from "../../utils/copyToClipboard";
export class CopyToClipboard {
    constructor() {
        this.textToCopy = undefined;
        this.clickToCopyIcon = "documents";
        this.clickToCopyIconSuccessful = "checkmark";
        this.clickToCopyMessage = undefined;
        this.clickToCopyMessageSuccessful = undefined;
        this.copyButtonLabel = "Copy the following text to clipboard:";
        this.hideTextToCopy = false;
        this.wasSuccessful = false;
    }
    baseClass = "ux-copy-to-clipboard";
    /** event emitted when the copy to clipboard function has been executed */
    copyToClipboard;
    clickHandler = (stringToCopy) => {
        copyToClipboard(stringToCopy)
            // @ts-expect-error Check for typing
            .then((response) => {
            this.wasSuccessful = response;
            this.copyToClipboard.emit({
                success: true,
                copiedText: stringToCopy
            });
        })
            .catch(function (err) {
            /* eslint-disable-next-line no-console */
            console.log("Could not copy link:", err);
            // @ts-expect-error Check for typing
            this.copyToClipboard.emit({ success: false, copiedText: null });
        });
        setTimeout(() => {
            this.wasSuccessful = false;
        }, 2000);
    };
    render() {
        return (h(Host, { key: '3f651271164d25b48a4c24dd9ad46bf3ef9f7c20', class: this.baseClass }, typeof this.textToCopy === "string" && (h("button", { key: '26338f903519c58ef843f4d3ea9191afcc151109', onClick: () => this.clickHandler(this.textToCopy), type: "button", "aria-label": `${this.copyButtonLabel} "${this.textToCopy}"`, class: `${this.baseClass}__button` }, !this.hideTextToCopy && h("span", { key: '6c7cfdf0fcf9a2bfc13f562fc36964fe1f580a71', class: `${this.baseClass}__text-to-copy` }, this.textToCopy), h("span", { key: 'af9b2a67b46f4673bcf85d69f09d3f18baf218df', class: `${this.baseClass}__copy-area` }, (this.clickToCopyMessage || this.clickToCopyMessageSuccessful) && (h("span", { key: '35f40acaa4091c5b14e11820b053a73db0ccf3af', class: `${this.baseClass}__message` }, this.wasSuccessful ? this.clickToCopyMessageSuccessful : this.clickToCopyMessage)), h("ux-icon", { key: '982b95ee11ffdb2179d77c89a06f4dd71b77255f', name: this.wasSuccessful ? this.clickToCopyIconSuccessful : this.clickToCopyIcon, weight: "normal" }))))));
    }
    static get is() { return "ux-copy-to-clipboard"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["copy-to-clipboard.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["copy-to-clipboard.css"]
        };
    }
    static get properties() {
        return {
            "textToCopy": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Link which can be copied"
                },
                "attribute": "text-to-copy",
                "reflect": true
            },
            "clickToCopyIcon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Default icon"
                },
                "attribute": "click-to-copy-icon",
                "reflect": false,
                "defaultValue": "\"documents\""
            },
            "clickToCopyIconSuccessful": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Icon shown after copy link was clicked"
                },
                "attribute": "click-to-copy-icon-successful",
                "reflect": false,
                "defaultValue": "\"checkmark\""
            },
            "clickToCopyMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Default message which indicates link is copyable"
                },
                "attribute": "click-to-copy-message",
                "reflect": false
            },
            "clickToCopyMessageSuccessful": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Message which gets shown after clicking the copy link"
                },
                "attribute": "click-to-copy-message-successful",
                "reflect": false
            },
            "copyButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label to be added to the button for accessibility purposes"
                },
                "attribute": "copy-button-label",
                "reflect": false,
                "defaultValue": "\"Copy the following text to clipboard:\""
            },
            "hideTextToCopy": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Setting wether link to be copied is hidden"
                },
                "attribute": "hide-text-to-copy",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "wasSuccessful": {}
        };
    }
    static get events() {
        return [{
                "method": "copyToClipboard",
                "name": "uxCopyToClipboard",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "event emitted when the copy to clipboard function has been executed"
                },
                "complexType": {
                    "original": "{\n        success: boolean;\n        copiedText: null | string;\n    }",
                    "resolved": "{ success: boolean; copiedText: string | null; }",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=copy-to-clipboard.js.map
